module.exports = {"440403001":"白藤街道","440403100":"莲洲镇","440403103":"斗门镇","440403105":"乾务镇","440403106":"白蕉镇","440403107":"井岸镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440403.json
// module id = 2102
// module chunks = 0